/**
 * Full-app overlay for in-flight HTTP via apiFetch / token fetch (outside AgentContext).
 * Hidden while ApiLoader is shown so only one spinner is visible.
 */

import { useSyncExternalStore } from 'react';
import {
  getGlobalApiLoadingCount,
  subscribeGlobalApiLoading,
} from '../../utils/globalApiLoading';
import {
  getAgentLoadingOverlayActive,
  subscribeAgentLoadingOverlay,
} from '../../utils/loadingOverlayCoordinator';
import './api-loader.scss';

export default function GlobalApiLoadingOverlay() {
  const pending = useSyncExternalStore(
    subscribeGlobalApiLoading,
    getGlobalApiLoadingCount,
    () => 0,
  );
  const agentLoaderVisible = useSyncExternalStore(
    subscribeAgentLoadingOverlay,
    getAgentLoadingOverlayActive,
    () => false,
  );

  if (pending <= 0 || agentLoaderVisible) return null;

  return (
    <div
      className="api-loader-overlay api-loader-overlay--minimal"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading"
    >
      <div className="api-loader-spinner-only" aria-hidden="true">
        <span className="api-loader-dot" />
      </div>
    </div>
  );
}
